export enum DEVICE {
  PHONE = 'phone',
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  CTV = 'ctv',
  CONSOLE = 'console',
  WEARABLE = 'wearable',
  EMBEDDED = 'embedded',
}
